import { render } from "./FtpBlock.vue?vue&type=template&id=729118fa"
import script from "./FtpBlock.vue?vue&type=script&lang=js"
export * from "./FtpBlock.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__